/**
 * @generated SignedSource<<7ad671ca05029bc7d22ce97ad7f78c4f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserAvatar$data = {
  readonly avatarURL: string;
  readonly username: string;
  readonly usernameID: string;
  readonly " $fragmentType": "UserAvatar";
};
export type UserAvatar$key = {
  readonly " $data"?: UserAvatar$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserAvatar">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserAvatar",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "username",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "usernameID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "avatarURL",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "b6c28b4a6dbb26f68770ce0de947de0c";

export default node;
